export default __webpack_public_path__ + "static/media/024-chocolate bar.666a9efc.svg";